import { FieldsContext } from '@mosanic/core/Map/ChildItem';
import { ProdFieldsContext } from '@mosanic/core/Map/ChildProd';
import { useContext } from 'react';

export const useContextReference = (isDev) => {
    const devReference = useContext(FieldsContext)
    const prodReference = useContext(ProdFieldsContext)
    const reference = isDev ? devReference : prodReference;
    return {...reference, isDev};
}